<template>
  <v-container
    fill-height
    fluid
    style="background: radial-gradient(rgb(0, 175, 255), rgb(49, 126, 235)) rgb(13, 166, 236);"
  >
    <v-row align="center" justify="center">
      <v-col style="text-align:center" xs12>
        <img
          src="@/assets/logo-reg.png"
          style="width: 70%;max-width:250px"
          class="justify-center"
        />
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col>
        <v-row fill-height align="center" justify="center">
          <v-col>
            <v-window v-model="onboarding" fill-height>
              <v-window-item
                v-for="(item, i) in items"
                :key="i"
                :src="item.src"
                style="height:100%"
                fill-height
              >
                <v-card color="transparent">
                  <v-layout
                    v-touch="{
                      left: () => swipe('Left'),
                      right: () => swipe('Right')
                    }"
                    align-center
                    justify-center
                    fill-height
                    tag="v-card-text"
                  >
                    <img
                      :src="item.src"
                      fill-height
                      rel="preload"
                      style="width:auto;max-height:300px;"
                    />
                  </v-layout>
                  <div class="d-flex justify-center" style="color: white;">
                    <h4>{{ item.givenText }}</h4>
                  </div>
                  <div class="d-flex justify-center" style="color: white;">
                    <h5>{{ item.givenTextExm }}</h5>
                  </div>
                </v-card>
              </v-window-item>
            </v-window>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col style="text-align:center">
            <v-item-group v-model="onboarding" xs12 class="text-xs-center">
              <v-item v-for="n in length" :key="`btn-${n}`">
                <v-btn
                  slot-scope="{ active, toggle }"
                  :input-value="active"
                  @click="toggle"
                  icon
                  text
                  small
                  color="white"
                >
                  <v-icon>mdi-record</v-icon>
                </v-btn>
              </v-item>
            </v-item-group>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-col>
        <v-row align="center" justify="center">
          <v-col style="text-align:right">
            <v-btn @click="loginDialog = true" style="max-width:100px">Sign in</v-btn>
          </v-col>

          <v-col style="text-align:left">
            <v-btn @click="signupDialog = true" style="background-color: #6aed6f;max-width:100px"
              >Sign up</v-btn
            >
          </v-col>
        </v-row>
        <!-- <v-row  align="center"
      justify="center">
              <v-btn
                color="white"
                class="forget-password-btn"
                href="#"
                text
                small
                icon
              >
              <v-icon>play_circle_outline</v-icon>
              Setup Tutorial
              </v-btn>
        </v-row>-->
      </v-col>
    </v-row>

    <!-- loader -->
    <v-dialog v-model="loaderDialog" persistent width="300">
      <v-card color="primary" style="padding: 5px">
        <v-card-text style="padding: 10px; color: #fcfcfc">
          <h3 style="font-size: 15px;color: #fcfcfc; margin: 7px 0px">Please stand by</h3>
          <v-progress-linear
            style="padding: 2px"
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loginErrorDialog" persistent width="300">
      <v-card elevation="1" style="background-color: #bf360c; padding: 5px">
        <v-card-text style="padding: 5px">
          <v-alert :value="true" style="padding: 10px 5px" color="error" icon="error" outline>
            <h3 style="color: #fcfcfc; margin-top: -8px">Invalid Email ID and/or Password</h3>
          </v-alert>
          <v-btn @click.native="loginErrorDialog = false" color="red" block class="white--text"
            >Close</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Wait for Login</v-card-title>
        <v-card-text>Wait till we log you in {{ username }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="green darken-1" flat>Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- login dialog -->
    <v-dialog v-model="loginDialog" persistent max-width="500px">
      <v-card elevation="1">
        <v-card-title class="primary">
          <h4 class="reg__heading">Login</h4>
        </v-card-title>

        <v-card-text style="padding: 10px 7px">
          <v-form @keyup.native.enter="login">
            <v-text-field
              v-model="username"
              @change="username = username.trim()"
              label="Email"
              prepend-icon="face"
              type="text"
              required
            ></v-text-field>

            <v-text-field
              v-model="password"
              :append-icon="visible ? 'visibility' : 'visibility_off'"
              @click:append="() => (visible = !visible)"
              :type="visible ? 'text' : 'password'"
              label="Password"
              prepend-icon="lock"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            @click="forgotDialogOpen"
            color="primary"
            class="forget-password-btn"
            href="#"
            text
            x-small
            >Forgot Password</v-btn
          >

          <v-spacer></v-spacer>
          <v-btn @click.native="loginDialog = false" color="primary" text>Close</v-btn>
          <v-btn :disabled="disableLoginBtn" @click="login" color="primary">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- forgot password dialog -->
    <v-dialog v-model="forgotDialog" persistent max-width="500px">
      <v-card elevation="1">
        <v-card-title class="primary">
          <h4 class="reg__heading">Forgot Password</h4>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding: 10px 7px">
          <v-form
            ref="forgotPasswordForm"
            v-on:submit.prevent="forgotPassword"
            @keyup.native.enter="forgotPassword"
          >
            <v-text-field
              v-model="forgotEmail"
              :rules="forgotEmailRules"
              required
              label="Email"
              prepend-icon="face"
              type="text"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click.native="forgotDialog = false"
            color="blue darken-1"
            style="font-size: 14px"
            text
            >Close</v-btn
          >

          <v-btn
            @click="forgotPassword"
            color="primary"
            class="white--text"
            style="letter-spacing: 1px; font-size: 14px"
            >Reset</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- sign up  -->
    <v-dialog v-model="signupDialog" persistent max-width="500px">
      <v-card elevation="1">
        <v-card-title class="primary">
          <h4 class="reg__heading">{{ currentTitle }}</h4>
          <v-spacer></v-spacer>
          <v-avatar
            v-text="step"
            color="primary lighten-2"
            class="subheading white--text"
            size="24"
          ></v-avatar>
        </v-card-title>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-window v-model="step">
            <v-window-item :value="1">
              <v-card-text @keyup.enter="nextform">
                <v-row>
                  <h3>Disclaimer</h3>
                  <h5>
                    Signing up creates a new organisation account in Regular.li. Please agree if you
                    are an administrator at your organisation and want to create a new account for
                    it
                  </h5>
                </v-row>

                <div class="d-flex justify-end">
                  <v-checkbox ref="agree_box" v-model="checkbox" :rules="agree_box" required>
                    <template v-slot:label>
                      <div>Do you agree?</div>
                    </template>
                  </v-checkbox>
                </div>
              </v-card-text>
            </v-window-item>

            <v-window-item :value="2">
              <v-card-text @keyup.enter="nextform">
                <v-text-field
                  ref="signupName"
                  v-model="signupName"
                  :rules="nameRules"
                  label="Name"
                  prepend-icon="face"
                  required
                ></v-text-field>

                <v-text-field
                  ref="signupOrganization"
                  v-model="signupOrganization"
                  :rules="orgRules"
                  label="Organization Name"
                  prepend-icon="supervised_user_circle"
                  required
                ></v-text-field>

                <v-autocomplete
                  v-model="signupCountry"
                  :items="getCountriesList()"
                  label="Country"
                  prepend-icon="location_city"
                  item-text="name"
                  item-value="name"
                  required
                ></v-autocomplete>
              </v-card-text>
            </v-window-item>

            <v-window-item :value="3">
              <v-card-text @keyup.enter="signup">
                <v-text-field
                  v-model="signupEmail"
                  :rules="emailRules"
                  label="Email"
                  prepend-icon="face"
                  required
                ></v-text-field>

                <v-text-field
                  :append-icon="visible ? 'visibility' : 'visibility_off'"
                  @click:append="() => (visible = !visible)"
                  :type="visible ? 'text' : 'password'"
                  v-model="signupPassword"
                  :rules="passwordRules"
                  label="Password"
                  prepend-icon="lock"
                  required
                ></v-text-field>

                <!-- <v-text-field
                        name="password"

                        label="Enter password"
                        :append-icon="value ? 'visibility' : 'visibility_off'"
                        @click:append="() => (value = !value)"
                        :type="value ? 'password' : 'text'"
                ></v-text-field>-->

                <v-text-field
                  :append-icon="confirm_visible ? 'visibility' : 'visibility_off'"
                  @click:append="() => (confirm_visible = !confirm_visible)"
                  :type="confirm_visible ? 'text' : 'password'"
                  v-model="signupConfirm"
                  :error-messages="confirmPasswordRules"
                  :rules="confirmPasswordRules"
                  label="Confirm Password"
                  prepend-icon="lock"
                  required
                ></v-text-field>
              </v-card-text>
            </v-window-item>
          </v-window>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn v-if="step != 1" @click="step--" text>Back</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              @click.native="signupDialog = false"
              color="primary"
              text
              class="white--text"
              style="font-size: 14px;"
              >Close</v-btn
            >
            <v-btn v-if="step === 1" @click="nextform" color="primary" class="continue-form-btn"
              >Continue</v-btn
            >

            <v-btn v-if="step === 2" @click="nextform" color="primary" class="sign-form-btn"
              >next</v-btn
            >

            <v-btn
              v-if="step === 3"
              :disabled="!valid"
              @click="signup"
              color="green"
              class="white--text"
              style="letter-spacing: 1px;"
              >Signup</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import countries from "../utilities/countries";
import encrypt from "../utilities/base64_encrypt.js";

export default {
  data() {
    return {
      checkbox: false,
      nameRules: [
        v => !!v || "Name is required",
        v => /^[A-Za-z0-9-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(v) || "Please enter a valid UserName"
      ],
      orgRules: [
        v => !!v || "Organization is required",
        v =>
          /^[A-Za-z0-9\-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(v) ||
          "Please enter a valid Organization Name"
      ],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/.test(v) || "E-mail must be valid"
      ],

      forgotEmailRules: [
        v => !!v || "E-mail is required",
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/.test(v) || "E-mail must be valid"
      ],
      agree_box: [v => !!v || "You must agree to continue"],
      confirm_visible: "",
      visible: "",
      value: "",
      forgotEmail: "",
      forgotDialog: false,
      email: "",
      password: "",
      loaderDialog: false,
      loginErrorDialog: false,
      dialog: false,
      signupDialog: false,
      loginDialog: false,
      username: "",
      password: "",
      signupEmail: "",
      signupConfirm: "",
      signupPassword: "",
      signupName: "",
      signupOrganization: "",
      signupCountry: "India",
      swipeDirection: "None",
      length: 4,
      onboarding: 0,
      step: 1,
      valid: true,
      disableLoginBtn: false,
      passwordRules: [
        v => !!v || "Password is required",
        v => /^[A-Za-z0-9\d\S\-]*$/.test(v) || "Please enter a valid Password"
      ],

      items: [
        {
          src: require("@/assets/4.png"),
          givenText: "Contactless Attendance",
          givenTextExm: "From Mobiles, Desktop or QR Scan"
        },
        {
          src: require("@/assets/2.png"),
          givenText: "Highly Secured",
          givenTextExm: "With GPS, WiFi and PhotoID"
        },
        {
          src: require("@/assets/3.png"),
          givenText: "Dynamic Forms",
          givenTextExm: "Track Submissions. Export reports"
        },
        {
          src: require("@/assets/1.png"),
          givenText: "Field Tracking",
          givenTextExm: "Track your outdoor users realtime"
        }
      ]
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    error() {
      return this.$store.getters.error;
    },
    signUpError() {
      return this.$store.getters.signUpError;
    },
    loading() {
      return this.$store.getters.loading;
    },
    userDetails() {
      return this.$store.getters.userDetails;
    },
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Sign Up";
        case 2:
          return "Sign Up";
        case 3:
          return "Sign Up";
        default:
          return "Sign Up";
      }
    },
    confirmPasswordRules() {
      return this.signupConfirm == this.signupPassword ? [] : ["Confirm password does not match"];
    }
  },

  watch: {
    userDetails(value) {
      if (value !== null && value !== undefined) {
        this.loginDialog = false;

        this.loaderDialog = false;

        if (this.$store.state.userDetails.kioskMode) {
          this.$router.push("/kiosk");
        } else {
          this.$router.push("/");
        }
      }
    },
    loading(value) {
      if (value == false) {
        this.loginDialog = false;
        this.loaderDialog = false;
      }
    },
    signUpError(value) {
      if (value != null) {
        if (value.body.error) {
          this.valid = true;
          this.loaderDialog = false;
          this.$swal({
            type: "warning",
            text: "Email ID is already in use"
          });
          return;
        }
        this.valid = true;
        this.loaderDialog = false;
        this.$swal({
          type: "warning",
          text: "Something went wrong. Try again later"
        });
      }
    },
    error(value) {
      console.log("Error", value);

      if (value != null) {
        if (value.body.error) {
          this.disableLoginBtn = false;
          this.loginErrorDialog = true;
          this.loginDialog = true;
          return;
        }
        this.disableLoginBtn = false;
        this.loginDialog = true;
        this.$swal({
          type: "error",
          text: "Something went wrong. Try again later"
        });
      }
    }
  },
  created() {
    if (Object.keys(this.$route.query).length > 0) {
      if (this.$route.query.l && this.$route.query.d) {
        try {
          console.log("case");
          var payload = {};
          payload.email = encrypt.Base64.decode(this.$route.query.l);
          payload.password = encrypt.Base64.decode(this.$route.query.d);
          payload.ttl = 60 * 60 * 24 * 7 * 6;
          this.$store.dispatch("signUserIn", payload);
        } catch (e) {
          console.log(e);
        }
      }
    }

    if (this.$store.state.userDetails) {
      if (this.$store.state.userDetails.kioskMode) {
        this.$router.push("/kiosk");
      } else {
        this.$router.push("/");
      }
    }
  },
  methods: {
    forgotDialogOpen() {
      this.forgotDialog = true;
      this.loginDialog = false;
    },
    nextform() {
      const self = this;
      if (this.step == 1) {
        if (this.$refs.agree_box.validate() == false) {
        } else {
          return self.step++;
        }
      } else if (
        this.$refs.signupName.validate() == false ||
        this.$refs.signupOrganization.validate() == false ||
        this.signupCountry == ""
      ) {
      } else {
        return self.step++;
      }
    },
    getCountriesList() {
      this.countries = countries;
      return this.countries;
    },
    forgotPassword(e) {
      e.preventDefault();

      if (!this.$refs.forgotPasswordForm.validate()) {
        return;
      }

      this.$http
        .post(`${this.$store.state.endpoint}Accounts/reset`, {
          email: this.forgotEmail
        })
        .then(res => {
          this.forgotDialog = false;
          this.forgotEmail = "";
          this.$swal({
            type: "success",
            text: "Please check your mail to reset your password."
          });
        })
        .catch(err => {
          if (err.body.error) {
            return this.$swal({ type: "error", text: err.body.error.message });
          }
          this.$swal({
            type: "error",
            text: "Something went wrong. Try again later"
          });
        });
    },

    login(e) {
      this.loaderDialog = true;
      this.disableLoginBtn = true;
      this.$store.dispatch("signUserIn", {
        email: this.username,
        password: this.password,
        ttl: 60 * 60 * 24 * 7 * 6
      });
      e.preventDefault();
    },
    signup() {
      const Name = this.signupName.trim();
      let signupFirstname = Name.split(" ")
        .slice(0, -1)
        .join(" ");
      let signupLastname = Name.split(" ")
        .slice(-1)
        .join(" ");

      if (signupFirstname == "") {
        signupFirstname = signupLastname;
        signupLastname = "";
      }
      if (this.signupEmail == "") {
        this.$swal({
          type: "error",
          text: "Invalid Email ID"
        });
        return;
      }
      if (this.signupPassword == "") {
        this.$swal({
          type: "error",
          text: "Invalid Password"
        });
        return;
      }
      if (this.signupPassword != this.signupConfirm || this.signupConfirm != this.signupPassword) {
        this.$swal({
          type: "error",
          text: "Passwords don’t match"
        });
        return;
      }
      this.loaderDialog = true;
      this.valid = false;
      const signupObj = {
        firstName: signupFirstname,
        lastName: signupLastname,
        email: this.signupEmail,
        password: this.signupPassword,
        confirmpassword: this.signupConfirm,
        orgName: this.signupOrganization,
        country: this.signupCountry
      };
      this.$store.dispatch("signUserUp", signupObj);
    },

    next() {
      this.onboarding = this.onboarding + 1 === length ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding = this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    },
    swipe(direction) {
      this.swipeDirection = direction;
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 100%;
  height: 100%;
}

.v-card {
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0),
    0 1px 3px 0 rgba(0, 0, 0, 0);
}
h3 {
  letter-spacing: 0.5px;
  font-weight: 500;
  margin-bottom: 10px;
  margin-left: 5px;
}
h5 {
  font-size: 14px;
  line-height: 17px;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 15px;
}
.agree_box {
  margin-top: 10px;
  margin-left: 5px;
}
.display-2 {
  font-size: 25px !important;
  letter-spacing: 1px !important;
  margin-left: 5px;
}
.login-btn {
  color: #ffffff;
  font-size: 16px;
  letter-spacing: 1px;
  font-weight: 400;
  box-shadow: 2px 4px 20px #d3d3d3 !important;
}
.front-show-btn {
  color: #f7f7f7;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 800 !important;
  width: 260px;
  box-shadow: 1px 2px 22px #636363 !important;
  border: none;
  color: #232323;
  border-radius: 3px;
}
.forget-password-btn {
  font-size: 10px;
  font-weight: 400 !important;
}
.sign-form-btn {
  letter-spacing: 0.5px;
}
.continue-form-btn {
  font-size: 14px;
  border-radius: 2px;
  letter-spacing: 0.5px;
}
.countryCss {
  border: 1px solid #616161;
  padding: 10px;
  width: 100%;
  border-radius: 5px;
}
</style>
